import { useEffect, useRef } from 'react';
// import { TextareaAutosize } from '@mui/base';
import { Box, FormLabel, Typography } from '@mui/material';
import BaseColorText from '../BaseColorText';

const BaseTextareaAutosize = ({
  label,
  id,
  rows = 3,
  placeholder,
  name,
  onChange,
  hasMaxLengthLabel = true,
  maxLength,
  required,
  value,
  error,
  sx,
  inputStyles
}) => {
  const textareaRef = useRef(null);

  // const [valueText, setValue] = useState('')

  useEffect(() => {
    const textarea = textareaRef.current;

    // Reset height to auto to recalculate scroll height
    textarea.style.height = 'auto';

    // Set height to the scrollHeight of the content
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, [value]); // Runs after every content update

  // useMemo(() => setValue(value), [value])

  // const handleChange = (e) => {
  //   if (e.target.value.length <= maxLength) {
  //     onChange(e)
  //   }
  // }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'inline-flex',
        flexDirection: 'column',
        ...sx,
      }}
    >
      {(hasMaxLengthLabel || label) && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: label ? 'space-between' : 'flex-end',
            alignItems: 'center'
          }}
        >
          {label && 
            <FormLabel
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                mb: '1px',
                color: '#46545F'
              }}
              htmlFor={id}
            >
              {label}
              {required && <BaseColorText color='#E73E3E'>*</BaseColorText>}
            </FormLabel>
          }
          <Box>
            <Typography variant='subText' color='primary.mediumGray'>{maxLength && `${value.length}/${maxLength}`}</Typography> 
          </Box>
        </Box>
      )}
      <Box>
        <textarea
          ref={textareaRef}
          id={id}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          // rows={rows}
          value={value}
          style={{
            fontFamily: 'Poppins',
            height: value === '' ? '30px !important' : 'auto',
            transition: 'height 0.2s ease',
            resize: 'none',
            overflowY: 'hidden',
            ...inputStyles
          }}
        />
      </Box>
      {error && (
        <Typography variant="subText" color='primary.red'>
          {error}
        </Typography>
      )}
    </Box>
  )
}

export default BaseTextareaAutosize